module.exports = __webpack_public_path__ + "img/newsImg11-34.d34164d0.png";